module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticStyle: {
      "padding": "15px",
      "background": "#fff"
    }
  }, [_c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "today"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    staticClass: "xs24",
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "seven"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "sm": 12,
      "xs": 24
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部游戏",
      "value": "内部游戏"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部游戏",
      "value": "外部游戏"
    }
  })], 1), _vm._v(" "), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "compare": "issued"
    },
    on: {
      "getid": _vm.changeId
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)], 1)])], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isChartShow),
      expression: "!isChartShow"
    }],
    staticStyle: {
      "min-width": "1200px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "500px"
    },
    attrs: {
      "id": "chart"
    }
  })]), _vm._v(" "), (_vm.cdata.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cdata.list,
      "stripe": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(scope) {
          return [(item.key == 'ltv') ? _c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": '截至' + _vm.pdata.edate + '的累计数据',
              "placement": "top-start"
            }
          }, [_c('span', [_vm._v(_vm._s(item.name)), _c('i', {
            staticClass: "el-icon-question"
          })])]) : _c('span', [_vm._v(_vm._s(item.name))])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '整体数据详情',
                params: {
                  issued_app_id: scope.row.issued_app_id
                },
                query: {
                  edate: _vm.pdata.edate,
                  sdate: _vm.pdata.sdate
                }
              })
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 2731992457)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.cdata.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80, 200, 500],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("设置显示字段")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("可选字段")]), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25c9fb22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/issue/totalData.vue
// module id = 1121
// module chunks = 2